import gql from 'graphql-tag';

export const getBuildingTenantChannels = gql`
  query getBuildingTenantChannels($channelId: UUID!) {
    getBuildingTenantChannels(channelId: $channelId) {
      channelId
      name
      inviteOnly
      hasFilters
    }
  }
`;
